import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const FadeIn = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 1.1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ number, title, kicker, children, className = "" }) => (
  <FadeIn className={`relative ${className}`}>
    <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
      <div className="md:col-span-3">
        <span className="font-mono-tech text-amber-500/70 text-sm tracking-[0.3em]">
          {number}
        </span>
        <span className="block w-10 h-px bg-amber-700/60 mt-3" />
      </div>
      <div className="md:col-span-9">
        {kicker && <p className="label-mono mb-4">{kicker}</p>}
        {title && (
          <h3 className="font-serif text-3xl md:text-4xl text-slate-100 tracking-tight mb-5">
            {title}
          </h3>
        )}
        <div className="text-slate-400 leading-relaxed text-base md:text-lg font-light max-w-2xl">
          {children}
        </div>
      </div>
    </div>
  </FadeIn>
);
